
import marketing from '~/mixins/marketing'
import { comparisonCatalog } from '~/content/marketing/catalog'
export default {
  mixins: [marketing],
  computed: { comparisons () { return comparisonCatalog(this.$i18n.locale) } }
}
